import { Spacer } from '@chakra-ui/react';
import { InsetShell } from '@ionq/legacy-ui';
import { MyAccountMenu } from './MyAccountMenu';
import { NotificationsMenu } from './NotificationsMenu';

// The shell's top bar, same shape as enterprise's: the invites bell and
// the account menu, trailing (the switcher stays pinned to the rail's band
// over it while collapsed). The pages name themselves.
export function AppNavbar() {
    return (
        <InsetShell.Navbar>
            <Spacer />
            <NotificationsMenu />
            <MyAccountMenu />
        </InsetShell.Navbar>
    );
}
